// extracted by mini-css-extract-plugin
export var documentation = "_kb-1";
export var menu = "_kb-0";